import { Observable } from 'rxjs';
import { Action } from '../base.action';
import { Reaction } from '../base.reaction';

export interface IEventHandler<K = any> {
  handler(
    source: Observable<Action<string, K> | Reaction>
  ): Observable<Action<string, K> | Reaction>;
}
